module.exports = __webpack_public_path__ + "img/product-banner_12.bd1cef96.png";